import React, { useEffect } from "react";
import { ThemeProvider } from "styled-components";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";

import { useModuleConfig, ModuleType } from "../";

import { Container } from "./competence.styled";
import { CheckAuthLayout } from '../../components';
import { NotFoundPage } from '../../app/notFoundPage/notFoundPage.component';

import { competenceRoutes } from './competence.routes';

const Competence = () => {
  const config = useModuleConfig(ModuleType.Competence);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (config.urls.includes(location.pathname)) {
      navigate(`${config.urls[1]}${config.routes.list}`, { replace: true });
    }
  }, [location.pathname, navigate]);

  return (
    <ThemeProvider theme={config.theme}>
      <Container>
        <Routes>
          <Route element={<CheckAuthLayout />}>
            {competenceRoutes.map((route) =>
              Object.values(route.pathSettings.urls).map((url, index) => {
                const Component = route.component;

                return (
                  <Route
                    key={`${url}-${index}`}
                    path={url}
                    element={<Component />}
                  />
                );
              })
            )}
          </Route>
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Container>
    </ThemeProvider>
  );
};

export default Competence;
